module.exports = __webpack_public_path__ + "media/images/aicon-arrow-right-purple-f8a8fc6726097efd91a54a99e52321fb.svg";